(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1059,4217],{

/***/ 73846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ getTranslations; }
/* harmony export */ });
const getTranslations = (t)=>{
    return {
        searchBrand: t("kf.search.label.searchBrand"),
        popularSearchText: t("kf.search.label.popularSearch"),
        topProductResults: (category)=>category !== "products" ? t("kf.search.label.topResults") : t("kf.search.label.topProductResults"),
        recentSearches: t("kf.search.label.recentSearch"),
        clearAll: t("kf.search.label.clearAll"),
        see: t("kf.search.label.see"),
        all: t("kf.search.label.all"),
        resultText: t("kf.search.label.resultsCaps"),
        searchCTA: t("kf.search.label.searchCTA"),
        top: t("kf.search.label.top"),
        product: t("kf.search.label.products"),
        topResult: t("kf.search.label.topResults"),
        saleText: t("kf.search.label.topResults"),
        colors: t("kf.search.label.colors"),
        color: t("kf.search.label.color"),
        brand: t("kf.search.label.brand"),
        new: t("kf.search.label.new"),
        sale: t("kf.search.label.sale"),
        topSuggestions: t("kf.search.label.topSuggestions"),
        yourSearch: t("kf.search.label.yourSearch"),
        seeAll: t("kf.search.label.seeAll"),
        results: t("kf.search.label.resultsCaps"),
        searchHeader: t("kf.search.label.searchHeader"),
        resultsCaps: t("kf.search.label.resultsCaps"),
        favSuccessMsg: t("kf.favorites.success"),
        favErrorMsg: t("kf.favorites.error"),
        favRemoveSuccessMsg: t("kf.favorites.removeItem"),
        favRemoveErrorMsg: t("kf.favorites.removeItemError"),
        sameCategory: t("kf.compare.validation.sameCategory"),
        maxProduct: t("kf.compare.validation.maxProducts"),
        addToCompare: t("kf.plp.label.addToCompare"),
        onSale: t("kf.plp.label.onSale"),
        ariaLabel: {
            close: t("kf.search.aria.label.close"),
            delete: (keyword)=>t("kf.search.aria.label.delete", {
                    keyword
                }),
            continue: t("kf.global.aria.label.continue"),
            addToCompare: (product)=>t("kf.plp.label.aria.addToCompare", {
                    product
                })
        },
        exclusive: t("kf.plp.label.exclusive"),
        newExclusive: t("kf.plp.label.newExclusive"),
        globalHome: t("kf.global.label.home")
    };
};


/***/ }),

/***/ 91059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Shared_HeaderNav; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./public/icons/BLOK_LOGO.svg
/* harmony default export */ var BLOK_LOGO = ({"src":"/_next/static/media/BLOK_LOGO.00edf835.svg","height":35,"width":115});
// EXTERNAL MODULE: ./components/Shared/HeaderNavTabs/analytics/index.js
var analytics = __webpack_require__(24897);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
;// CONCATENATED MODULE: ./components/Shared/HeaderNavLogo.jsx






const HeaderNavLogo = (props)=>{
    var ref;
    const { data ={} , columnClassNames ="" , eventHandler: { store: { brandLogoImg =""  } = {} , callbacks: { setBrandLogoImg =()=>{} , toggleMenu =()=>{}  }  } , v3 , isOpen , ariaControls =""  } = props;
    const hamburgericon = "/icons/icon-Hamburger.svg";
    (0,react.useEffect)(()=>{
        setBrandLogoImg(BLOK_LOGO === null || BLOK_LOGO === void 0 ? void 0 : BLOK_LOGO.src);
    }, []);
    const toggleMenuCall = ()=>{
        (0,helper.removeMavenoidChat)();
        toggleMenu();
        (0,analytics/* hamburgerMenuDatalayer */.w_)();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "gbh-hamber-menu icon-Hamburger",
                tabIndex: "0",
                "aria-label": "Hamburger-menu",
                role: "button",
                onClick: toggleMenuCall,
                "aria-expanded": isOpen,
                "aria-controls": ariaControls,
                children: v3 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: hamburgericon,
                    alt: ""
                }) : null
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                role: "img",
                "aria-label": "The Bold Look of Kohler logo",
                tabIndex: "0",
                className: "cmp cmp-image ".concat((data === null || data === void 0 ? void 0 : data.appliedCssClassNames) ? data === null || data === void 0 ? void 0 : data.appliedCssClassNames : "", " ").concat(columnClassNames ? columnClassNames : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    tabIndex: "-1",
                    href: data === null || data === void 0 ? void 0 : (ref = data.link) === null || ref === void 0 ? void 0 : ref.split("/content/kohler/us").join("").replace(".html", ""),
                    title: data === null || data === void 0 ? void 0 : data.alt,
                    className: "cmp-image--link",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        children: brandLogoImg && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(brandLogoImg),
                            alt: data === null || data === void 0 ? void 0 : data.alt
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Shared_HeaderNavLogo = (HeaderNavLogo);

// EXTERNAL MODULE: ./node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(29238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
// EXTERNAL MODULE: ./components/core/Image/DynamicImage.jsx
var DynamicImage = __webpack_require__(18377);
// EXTERNAL MODULE: ./hooks/useSmartCrop.js
var useSmartCrop = __webpack_require__(83886);
// EXTERNAL MODULE: ./hooks/useIsSsr.js
var useIsSsr = __webpack_require__(2595);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
;// CONCATENATED MODULE: ./components/Shared/ProductsNavTab.jsx












const ProductsNavTab = (props)=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    const { navOpen , setNavOpen , productNavigationItems , onClickNav , eventHandler: { store: { isOpen  }  } , datalayerPageName , selectedTab , hideMobImages , showMobileImages  } = props;
    const { locale , asPath  } = (0,next_router.useRouter)();
    const routerAsPath = "/" + locale + asPath;
    const [changePath, setChangePath] = (0,react.useState)();
    const [activeMainCategory, setActiveMainCategory] = (0,react.useState)("");
    const [activeSubCategory, setActiveSubCategory] = (0,react.useState)("");
    const isSsr = (0,useIsSsr/* default */.Z)();
    const smartCrop = (0,useSmartCrop/* default */.Z)();
    const onHoverMainCategory = (name)=>{
        setActiveMainCategory(name);
    };
    const onHoverSubCategory = (name)=>{
        setActiveSubCategory(name);
    };
    (0,react.useEffect)(()=>{
        setChangePath(routerAsPath);
    }, []);
    (0,react.useEffect)(()=>{
        if (!isOpen || !navOpen) {
            setActiveSubCategory("");
            setActiveMainCategory("");
        }
    }, [
        isOpen,
        navOpen
    ]);
    (0,react.useEffect)(()=>{
        if (changePath !== routerAsPath) {
            setNavOpen("");
            setChangePath(routerAsPath);
        }
    }, [
        routerAsPath
    ]);
    (0,react.useEffect)(()=>{
        if (productNavigationItems && activeMainCategory) {
            productNavigationItems.map((mainCategory, i)=>{
                if ((mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName) === activeMainCategory) {
                    const subCategoryDetails = mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.subCategoryDetails;
                    if (subCategoryDetails) {
                        const childItem = (subCategoryDetails === null || subCategoryDetails === void 0 ? void 0 : subCategoryDetails.childItems[0]) || null;
                        if (childItem) {
                            const activeSubCategory = (childItem === null || childItem === void 0 ? void 0 : childItem.subCategory) || null;
                            if (activeSubCategory) {
                                setActiveSubCategory(activeSubCategory);
                            }
                        }
                    }
                }
            });
        }
    }, [
        activeMainCategory,
        productNavigationItems
    ]);
    const handleOnClick = (item)=>{
        onHoverMainCategory(!(!(item === null || item === void 0 ? void 0 : item.categoryLinkRef) && (item === null || item === void 0 ? void 0 : item.categoryLink)) ? item === null || item === void 0 ? void 0 : item.categoryName : "");
        const prodnavsubmenu = document.querySelector(".gbh-global-tab .cmp-tabs");
        prodnavsubmenu === null || prodnavsubmenu === void 0 ? void 0 : prodnavsubmenu.scroll(0, 0);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        role: "tabpanel",
        tabIndex: "-1",
        className: "cmp-tabs__tabpanel ".concat(navOpen === t("kf.nav.label.products") ? "cmp-tabs__tabpanel--active" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat(constants.staticClasses.CONTAINER),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cmp-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "aem-Grid aem-Grid--11 aem-Grid--default--11 ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "globalnavigation aem-GridColumn aem-GridColumn--default--12",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "gbh-product-menu ".concat(hideMobImages ? "hide-mobile-images" : "", " ").concat(navOpen === t("kf.nav.label.products") ? "open" : ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "gbh-pro-menu__inner",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: "flex-column gbh-pro-menu__list nav",
                                            role: "tablist",
                                            "aria-label": "list of 6",
                                            tabIndex: "0",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    className: "gbh-mob-back-btn",
                                                    onClick: ()=>onClickNav({
                                                            "cq:panelTitle": navOpen
                                                        }),
                                                    children: "Menu"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "global-menu-selected",
                                                    children: t("kf.nav.label.products")
                                                }),
                                                productNavigationItems && productNavigationItems.map((item, index)=>{
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: "nav-item",
                                                        "data-tab": item === null || item === void 0 ? void 0 : item.categoryName,
                                                        role: "tab",
                                                        onClick: ()=>handleOnClick(item),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: "gbh-data-layer nav-link ".concat((item === null || item === void 0 ? void 0 : item.categoryName) === activeMainCategory ? "link-active" : ""),
                                                            "aria-hidden": "false",
                                                            "aria-label": item === null || item === void 0 ? void 0 : item.categoryName,
                                                            "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"'.concat(datalayerPageName).concat(datalayerPageName ? ":" : "", 'global header","internalLinkURL":"","internalLinkName":"products > ').concat(item === null || item === void 0 ? void 0 : item.categoryName.toLowerCase(), '","eventName":"main dropdown menu","internalLinkType":"global header:navigation","eventType":"global navigation","eventAction":"main dropdown menu"}'),
                                                            "data-hover": "tab",
                                                            "data-target": "#submenu".concat(item === null || item === void 0 ? void 0 : item.categoryName.toLowerCase().split(" ").join("-")),
                                                            "aria-controls": "submenu".concat(item === null || item === void 0 ? void 0 : item.categoryName.toLowerCase().split(" ").join("-")),
                                                            rel: "noreferrer",
                                                            role: "tab",
                                                            tabIndex: "0",
                                                            href: !(item === null || item === void 0 ? void 0 : item.categoryLinkRef) && (item === null || item === void 0 ? void 0 : item.categoryLink) ? (0,helper.removeAndCleanLink)(item === null || item === void 0 ? void 0 : item.categoryLink) : null,
                                                            "aria-selected": (item === null || item === void 0 ? void 0 : item.categoryLinkRef) ? "true" : "",
                                                            "aria-expanded": (item === null || item === void 0 ? void 0 : item.categoryLinkRef) ? "true" : "",
                                                            children: item === null || item === void 0 ? void 0 : item.categoryName
                                                        })
                                                    }, "productNavigation-".concat(index));
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tab-content gbh-pro-menu__cont",
                                            children: productNavigationItems && productNavigationItems.map((mainCategory, i)=>{
                                                var ref, ref1;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "tab-pane fade ".concat((mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName) === activeMainCategory ? "active show" : ""),
                                                    role: "tabpanel",
                                                    "aria-labelledby": mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "cmp-container",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "aem-Grid aem-Grid--12 aem-Grid--default--12 ",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "globalnavigation-subcategory aem-GridColumn aem-GridColumn--default--12",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                                        className: "nav gbh-pro-collection gbh-two-column",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                className: "gbh-mob-back-btn",
                                                                                onClick: ()=>onHoverMainCategory(""),
                                                                                children: t("kf.nav.label.products")
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "global-menu-selected sub-cat-select",
                                                                                children: mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName
                                                                            }),
                                                                            (mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.subCategoryDetails) && (mainCategory === null || mainCategory === void 0 ? void 0 : (ref = mainCategory.subCategoryDetails) === null || ref === void 0 ? void 0 : ref.childItems.map((subCategory, j)=>{
                                                                                var ref, ref1;
                                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                    className: "nav-item gbh-pro-collection__category-link",
                                                                                    onMouseOver: ()=>{
                                                                                        return onHoverSubCategory(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory);
                                                                                    },
                                                                                    children: routerAsPath === (0,helper.removeAndCleanLink)(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subLink) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                        "data-purelink": "true",
                                                                                        href: (0,helper.removeAndCleanLink)(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subLink),
                                                                                        className: "gbh-data-layer nav-link",
                                                                                        id: "pills-".concat(mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName.split(" ").join("-"), "-").concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-"), "-tab"),
                                                                                        "aria-hidden": "false",
                                                                                        "aria-label": "tab ".concat(j, " of ").concat(mainCategory === null || mainCategory === void 0 ? void 0 : (ref = mainCategory.subCategoryDetails) === null || ref === void 0 ? void 0 : ref.childItems.length, " Collections"),
                                                                                        "data-hover": "tab",
                                                                                        tabIndex: "0",
                                                                                        target: "_self",
                                                                                        "data-target": "#".concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-")).concat(mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName.toLowerCase().split(" ").join("-")),
                                                                                        role: "link",
                                                                                        "aria-controls": "pills-".concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-")),
                                                                                        "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"'.concat(datalayerPageName).concat(datalayerPageName ? ":" : "", 'global header","internalLinkURL":"').concat((0,helper.removeAndCleanLink)(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subLink), '","internalLinkName":" ').concat(selectedTab, " > ").concat(mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName.toLowerCase().split(" ").join("-"), " > ").concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-"), '","eventName":"main dropdown menu","internalLinkType":"global header:navigation","eventType":"global navigation","eventAction":"main dropdown menu"}'),
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "nav-link",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                dangerouslySetInnerHTML: {
                                                                                                    __html: browser_default().sanitize(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory)
                                                                                                }
                                                                                            })
                                                                                        })
                                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                        href: (0,helper.removeAndCleanLink)(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subLink),
                                                                                        className: "gbh-data-layer nav-link",
                                                                                        id: "pills-".concat(mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName.split(" ").join("-"), "-").concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-"), "-tab"),
                                                                                        "aria-hidden": "false",
                                                                                        "aria-label": "tab ".concat(j, " of ").concat(mainCategory === null || mainCategory === void 0 ? void 0 : (ref1 = mainCategory.subCategoryDetails) === null || ref1 === void 0 ? void 0 : ref1.childItems.length, " Collections"),
                                                                                        "data-hover": "tab",
                                                                                        tabIndex: "0",
                                                                                        target: "_self",
                                                                                        "data-target": "#".concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-")).concat(mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName.toLowerCase().split(" ").join("-")),
                                                                                        role: "link",
                                                                                        "aria-controls": "pills-".concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-")),
                                                                                        "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"'.concat(datalayerPageName).concat(datalayerPageName ? ":" : "", 'global header","internalLinkURL":"').concat((0,helper.removeAndCleanLink)(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subLink), '","internalLinkName":" ').concat(selectedTab, " > ").concat(mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName.toLowerCase().split(" ").join("-"), " > ").concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-"), '","eventName":"main dropdown menu","internalLinkType":"global header:navigation","eventType":"global navigation","eventAction":"main dropdown menu"}'),
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "nav-link",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                dangerouslySetInnerHTML: {
                                                                                                    __html: browser_default().sanitize(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory)
                                                                                                }
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                }, "subCategory-".concat(j));
                                                                            }))
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "tab-content gbh-pro-collection-cont gbh-two-column",
                                                                        children: (mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.subCategoryDetails) && (mainCategory === null || mainCategory === void 0 ? void 0 : (ref1 = mainCategory.subCategoryDetails) === null || ref1 === void 0 ? void 0 : ref1.childItems.map((subCategory, j)=>{
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "tab-pane fade gbh-mob-col ".concat((subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory) === activeSubCategory ? "active show" : ""),
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                    href: (0,helper.removeAndCleanLink)(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subLink),
                                                                                    className: "gbh-data-layer",
                                                                                    "data-gbh-data-layer": '{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"'.concat(datalayerPageName).concat(datalayerPageName ? ":" : "", 'global header","internalLinkURL":"').concat((0,helper.removeAndCleanLink)(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subLink), '","internalLinkName":" > ').concat(mainCategory === null || mainCategory === void 0 ? void 0 : mainCategory.categoryName.toLowerCase().split(" ").join("-"), " > ").concat(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory.split(" ").join("-"), '","eventName":"main dropdown menu","internalLinkType":"global header:navigation","eventType":"global navigation","eventAction":"main dropdown menu"}'),
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "hello gbh-subcattext",
                                                                                            children: (0,helper.sanitizeInnerHtml)(subCategory === null || subCategory === void 0 ? void 0 : subCategory.subCategory)
                                                                                        }),
                                                                                        showMobileImages && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            className: "cmp-image",
                                                                                            children: [
                                                                                                smartCrop.scriptStatus && !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicImage["default"], {
                                                                                                    imgUrl: subCategory === null || subCategory === void 0 ? void 0 : subCategory.sceneSevenImage,
                                                                                                    alt: subCategory === null || subCategory === void 0 ? void 0 : subCategory.imageAlt,
                                                                                                    className: "cmp-image__image with-crop",
                                                                                                    uniqueId: "subcatImage-".concat(j)
                                                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                                    src: subCategory === null || subCategory === void 0 ? void 0 : subCategory.sceneSevenImage,
                                                                                                    alt: subCategory === null || subCategory === void 0 ? void 0 : subCategory.imageAlt,
                                                                                                    className: "cmp-image__image without-crop"
                                                                                                }, "subcatImage-".concat(j)),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                    dangerouslySetInnerHTML: {
                                                                                                        __html: browser_default().sanitize(subCategory === null || subCategory === void 0 ? void 0 : subCategory.description)
                                                                                                    }
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }, "subcatInfo-".concat(j));
                                                                        }))
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                }, "mainCategory-".concat(i));
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "gbh-promenu-close-btn icon-Close-Large",
                                            "aria-label": "close",
                                            role: "button",
                                            tabIndex: "0",
                                            onClick: ()=>{
                                                setNavOpen("");
                                                setActiveMainCategory("");
                                                setActiveSubCategory();
                                                (0,helper.preventBodyScrollTab)(false);
                                                (0,analytics/* addAnalyticsOnClose */.hJ)();
                                            }
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "productbg ".concat(navOpen === t("kf.nav.label.products") ? "open" : "")
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var Shared_ProductsNavTab = (ProductsNavTab);

// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
;// CONCATENATED MODULE: ./components/Shared/HeaderNavTabs/index.jsx











const HeaderNavTabs = (props)=>{
    const { data , columnClassNames , eventHandler , eventHandler: { store: { isOpen  } , callbacks: { toggleMenu =()=>{} , setMainCategory =()=>{}  }  } , wrapperId =""  } = props;
    const { pageIsInteractive , datalayerPageName  } = (0,es/* useSelector */.v9)(genericSlice.selectGenericState);
    const [productNavigationItems, setProductNavigationItems] = (0,react.useState)(null);
    const [hideMobImages, setHideMobImages] = (0,react.useState)(false);
    const [navOpen, setNavOpen] = (0,react.useState)("");
    const [selectedTab, setTab] = (0,react.useState)("");
    const menuVisible = (0,react.useRef)(0);
    const [showMobileImages, setShowMobileImages] = (0,react.useState)(true);
    const dataRecursion = (0,react.useCallback)((data)=>{
        const { mainNavigation , categoryItems , hideMobileImages  } = data;
        if (data && mainNavigation === "Products") {
            setProductNavigationItems(categoryItems);
            setHideMobImages(hideMobileImages);
        }
        if (data && data[":itemsOrder"]) {
            data[":itemsOrder"].map((key, index)=>{
                const item = data[":items"][key];
                return dataRecursion(item);
            });
        }
    }, []);
    (0,react.useEffect)(()=>{
        if (lib/* isMobile */.tq && hideMobImages) {
            setShowMobileImages(false);
        } else {
            setShowMobileImages(true);
        }
    }, [
        hideMobImages,
        lib/* isMobile */.tq
    ]);
    const onClickNav = (data)=>{
        if (selectedTab !== data["cq:panelTitle"]) {
            setTab(data["cq:panelTitle"]);
        }
        if (navOpen !== data["cq:panelTitle"]) {
            setNavOpen(data["cq:panelTitle"]);
            if (!lib/* isMobile */.tq) {
                setNavOpen(data["cq:panelTitle"]);
            }
            setMainCategory({
                item: data["cq:panelTitle"]
            });
            menuVisible.current = 1;
            (0,helper.preventBodyScrollTab)(true);
            addHeaderNavTabAnalytics(data);
        } else {
            setNavOpen("");
            setTab("");
            setMainCategory({
                item: ""
            });
            menuVisible.current = 0;
            (0,helper.preventBodyScrollTab)(false);
        }
    };
    const addHeaderNavTabAnalytics = (data)=>{
        const eventInfo = {
            eventAction: "global header:".concat(data["cq:panelTitle"].toLowerCase()),
            eventName: "global header:".concat(data["cq:panelTitle"].toLowerCase()),
            eventType: "tab",
            internalLinkName: data["cq:panelTitle"].toLowerCase(),
            internalLinkPosition: "global header",
            internalLinkType: "global navigation",
            internalLinkZoneName: "global header",
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
        const page = window.pageObj || {};
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo
        });
    };
    const onMenuClickEvent = (e)=>{
        var ref, ref1, ref2, ref3, ref4;
        if (((e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.contains("gbh-pro-menu__inner")) || (e === null || e === void 0 ? void 0 : (ref2 = e.target) === null || ref2 === void 0 ? void 0 : ref2.closest(".gbh-pro-menu__inner")) === null && (e === null || e === void 0 ? void 0 : (ref3 = e.target) === null || ref3 === void 0 ? void 0 : ref3.closest(".gbh-full-w-menu__inner")) === null && (e === null || e === void 0 ? void 0 : (ref4 = e.target) === null || ref4 === void 0 ? void 0 : ref4.closest(".cmp-tabs__tablist")) === null && !lib/* isMobile */.tq) && menuVisible.current) {
            setNavOpen("");
            setTab("");
            setMainCategory({
                item: ""
            });
            menuVisible.current = 0;
            (0,helper.preventBodyScrollTab)(false);
        }
    };
    (0,react.useEffect)(()=>{
        if (navOpen) {
            document.addEventListener("click", onMenuClickEvent);
        } else {
            document.removeEventListener("click", onMenuClickEvent);
        }
        return ()=>document.removeEventListener("click", onMenuClickEvent);
    }, [
        navOpen
    ]);
    (0,react.useEffect)(()=>{
        dataRecursion(data);
    }, [
        data,
        dataRecursion
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tabs ".concat((data === null || data === void 0 ? void 0 : data.appliedCssClassNames) ? data === null || data === void 0 ? void 0 : data.appliedCssClassNames : "", " ").concat(columnClassNames ? columnClassNames : "", " ").concat(isOpen ? "open" : ""),
        id: wrapperId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "cmp-tabs",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "gbh-hamber-menu gbh-close icon-Close-Medium",
                    "aria-label": "close button",
                    tabIndex: "0",
                    onClick: ()=>{
                        toggleMenu();
                        onClickNav({
                            "cq:panelTitle": navOpen
                        });
                        (0,analytics/* addAnalyticsOnClose */.hJ)();
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                    role: "tablist",
                    className: "cmp-tabs__tablist",
                    "aria-multiselectable": "false",
                    children: [
                        data[":itemsOrder"] && data[":itemsOrder"].map((key, index)=>{
                            const item = data[":items"][key];
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                role: "tab",
                                className: "cmp-tabs__tab ".concat(selectedTab === item["cq:panelTitle"] ? "cmp-tabs__tab--active" : ""),
                                tabIndex: "0",
                                onClick: ()=>onClickNav(item),
                                children: item["cq:panelTitle"]
                            }, "navItem-".concat(index));
                        }),
                        (data === null || data === void 0 ? void 0 : data.mainTabId) && Object.keys(data === null || data === void 0 ? void 0 : data.mainTabId).map((key, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                role: "tab",
                                className: "cmp-tabs__tab",
                                tabIndex: "0",
                                children: key
                            }, "navItem-".concat(index));
                        })
                    ]
                }),
                pageIsInteractive && /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_ProductsNavTab, {
                    productNavigationItems: productNavigationItems,
                    navOpen: navOpen,
                    setNavOpen: (data)=>setNavOpen(data),
                    onClickNav: onClickNav,
                    isOpen: isOpen,
                    eventHandler: eventHandler,
                    datalayerPageName: datalayerPageName,
                    selectedTab: selectedTab,
                    hideMobImages: hideMobImages,
                    showMobileImages: showMobileImages
                }),
                data[":itemsOrder"] && data[":itemsOrder"].map((key, index)=>{
                    var ref;
                    const items = data[":items"][key];
                    const item = (ref = items[":items"]) === null || ref === void 0 ? void 0 : ref.globalnavigation;
                    if ((item === null || item === void 0 ? void 0 : item.mainNavigation) === "drawer" && navOpen === items["cq:panelTitle"]) {
                        var ref1, ref2, ref3, ref4;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "tabpanel",
                            tabIndex: "-1",
                            className: "cmp-tabs__tabpanel ".concat(navOpen === items["cq:panelTitle"] ? "cmp-tabs__tabpanel--active" : ""),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(constants.staticClasses.CONTAINER),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cmp-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "aem-Grid aem-Grid--11 aem-Grid--default--11 ",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "globalnavigation aem-GridColumn aem-GridColumn--default--11",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "gbh-full-w-menu",
                                                    style: {
                                                        transition: "all 2s ease 0s"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "bg-dim",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "gbh-full-w-menu__inner",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "gbh-full-max-width",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "gbh-full-w-menu__left-cont",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "gbh-full-w-menu__left-cont__top",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "gbh-full-w-menu__left-cont__top__cont",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            dangerouslySetInnerHTML: {
                                                                                                __html: browser_default().sanitize(item.mainTitle)
                                                                                            }
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "gbh-full-w-menu__left-cont__description",
                                                                                            style: {
                                                                                                transition: "none 0s ease 0s"
                                                                                            },
                                                                                            dangerouslySetInnerHTML: {
                                                                                                __html: browser_default().sanitize(item.description)
                                                                                            }
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                                                    className: "nav flex-column gbh-full-w-menu__left-cont__menu-list",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                            className: "gbh-mob-back-btn",
                                                                                            onClick: ()=>onClickNav({
                                                                                                    "cq:panelTitle": navOpen
                                                                                                }),
                                                                                            children: "Menu"
                                                                                        }),
                                                                                        item === null || item === void 0 ? void 0 : (ref1 = item.drawerItems) === null || ref1 === void 0 ? void 0 : ref1.map((navItem, index)=>{
                                                                                            var ref, ref1, ref2;
                                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                                className: "nav-item ",
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                                    className: "gbh-data-layer nav-link".concat((navItem === null || navItem === void 0 ? void 0 : navItem.subNavLinkRef) ? " extranal-sub-nav" : "", " "),
                                                                                                    target: "".concat(navItem.newTab ? "_blank" : "_self"),
                                                                                                    href: (ref = navItem.subNavLink) === null || ref === void 0 ? void 0 : ref.split("/content/kohler/us").join("").replace(".html", ""),
                                                                                                    "data-gbh-data-layer": '{"clickInternalLinks":"'.concat((navItem === null || navItem === void 0 ? void 0 : navItem.subNavLinkRef) ? "false" : "true", '","internalLinkPosition":"global header","internalLinkZoneName":"').concat(datalayerPageName).concat(datalayerPageName ? ":" : "", 'global header","internalLinkURL":"').concat(navItem === null || navItem === void 0 ? void 0 : (ref1 = navItem.subNavLink) === null || ref1 === void 0 ? void 0 : ref1.split("/content/kohler/us").join("").replace(".html", ""), '","internalLinkName":"').concat((ref2 = items["cq:panelTitle"]) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(), " > ").concat(navItem === null || navItem === void 0 ? void 0 : navItem.subNavName.toLowerCase(), '","eventName":"main dropdown  menu","internalLinkType":"global header:navigation","eventType":"global navigation","eventAction":"main dropdown menu"}'),
                                                                                                    rel: "".concat((navItem === null || navItem === void 0 ? void 0 : navItem.subNavLinkRef) ? "noreferrer" : ""),
                                                                                                    "data-hover": "tab",
                                                                                                    role: "link",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                            dangerouslySetInnerHTML: {
                                                                                                                __html: browser_default().sanitize(navItem.subNavName)
                                                                                                            }
                                                                                                        }),
                                                                                                        (navItem === null || navItem === void 0 ? void 0 : navItem.subNavLinkRef) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                            className: "sub-cat-img",
                                                                                                            children: (item === null || item === void 0 ? void 0 : item.externalIconCheckbox) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                                                src: item === null || item === void 0 ? void 0 : item.externalIcon,
                                                                                                                alt: "external link",
                                                                                                                href: navItem.subNavLink
                                                                                                            })
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            }, "navItem-".concat(index));
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "gbh-full-w-menu__right-img",
                                                                        children: (item === null || item === void 0 ? void 0 : (ref2 = item.drawerImage) === null || ref2 === void 0 ? void 0 : ref2.imageUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicImage["default"], {
                                                                            imgUrl: item === null || item === void 0 ? void 0 : (ref3 = item.drawerImage) === null || ref3 === void 0 ? void 0 : ref3.imageUrl,
                                                                            className: "cmp-image__image",
                                                                            alt: item === null || item === void 0 ? void 0 : (ref4 = item.drawerImage) === null || ref4 === void 0 ? void 0 : ref4.imageAlt
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "productbg"
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        }, "navTabs-".concat(index));
                    }
                })
            ]
        })
    });
};
/* harmony default export */ var Shared_HeaderNavTabs = (HeaderNavTabs);

// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./store/features/favoritesSlice.js + 1 modules
var favoritesSlice = __webpack_require__(7737);
// EXTERNAL MODULE: ./components/Shared/MiniCart/v1/MiniCart.jsx + 4 modules
var MiniCart = __webpack_require__(67101);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./components/Shared/UtilityWidgets/v1/UtilityWidgets.module.scss
var UtilityWidgets_module = __webpack_require__(84181);
var UtilityWidgets_module_default = /*#__PURE__*/__webpack_require__.n(UtilityWidgets_module);
// EXTERNAL MODULE: ./components/Default/DynamicSearch/v1/SearchPanel/localization.js
var localization = __webpack_require__(73846);
// EXTERNAL MODULE: ./store/features/productListSlice.js
var productListSlice = __webpack_require__(49682);
// EXTERNAL MODULE: ./store/features/searchSlice.js
var searchSlice = __webpack_require__(57879);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./utils/product.js
var product = __webpack_require__(29843);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
// EXTERNAL MODULE: ./hooks/useWindowDimensions.js
var useWindowDimensions = __webpack_require__(30394);
;// CONCATENATED MODULE: ./components/Shared/UtilityWidgets/v1/UtilityWidgets.jsx























const SearchPanel = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(1976), __webpack_require__.e(768), __webpack_require__.e(9804), __webpack_require__.e(9562), __webpack_require__.e(3389)]).then(__webpack_require__.bind(__webpack_require__, 46218)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(46218)
            ]
    }
});
const UtilityWidgets = (props)=>{
    var ref;
    const iconSearch = "/icons/search-Icon.svg";
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { searchHeader =""  } = (0,localization/* getTranslations */.F)(t);
    const router = (0,next_router.useRouter)();
    let analyticsEventData = {};
    const { columnClassNames , data , eventHandler  } = props;
    const { isAuth  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const dispatch = (0,es/* useDispatch */.I0)();
    const persona = (0,helper.getUserPersona)();
    const isSsr = (0,useIsSsr/* default */.Z)();
    const currencySign = (0,react.useRef)("");
    const currencyCode = (0,react.useRef)("");
    const searchPagePath = (0,react.useRef)("");
    const knowledgeArticleUrl = (0,react.useRef)("");
    const [showSearchBar, setShowSearchBar] = (0,react.useState)(false);
    const [selectedData, setSelectedData] = (0,react.useState)({});
    const [searchString, setSearchString] = (0,react.useState)("");
    var ref1;
    const [searchHistory, setSearchHistory] = (0,react.useState)((ref1 = JSON.parse(localStorage.getItem("keyWordList"))) !== null && ref1 !== void 0 ? ref1 : []);
    const [brandName, setBrandName] = (0,react.useState)("kohler");
    const [prevSearch, setPrevSearch] = (0,react.useState)("");
    const [searchTotal, setSearchTotal] = (0,react.useState)(0);
    const [searchProfileTotal, setSearchProfileTotal] = (0,react.useState)(0);
    const [topSuggestedData, setTopSuggestedData] = (0,react.useState)("");
    const [isCTAClicked, setIsCTAClicked] = (0,react.useState)(false);
    const [redirectUrl, setRedirectUrl] = (0,react.useState)("");
    const [category, setCategory] = (0,react.useState)("");
    const [tilesData, setTilesData] = (0,react.useState)([]);
    const [productsLoaded, setProductsLoaded] = (0,react.useState)(false);
    const [xfLink, setXfLink] = (0,react.useState)("");
    const [promoLayout, setPromoLayout] = (0,react.useState)("one-column");
    const [isGlobalConfigBlank, setIsGlobalConfigBlank] = (0,react.useState)(true);
    const [fusionFullCatalogResponse, setFusioFullCatalognResponse] = (0,react.useState)([]);
    const [isSterling, setIsSterling] = (0,react.useState)(false);
    const [redirectTileToKohelerPLP, setRedirectTileToKohelerPLP] = (0,react.useState)("");
    const selectedFavoritesState = (0,es/* useSelector */.v9)(favoritesSlice/* selectFavoritesState */.Qx);
    const { favorites  } = selectedFavoritesState || {};
    const { lineItems =[]  } = favorites || {};
    const { winWidth  } = (0,useWindowDimensions/* default */.Z)();
    (0,react.useEffect)(()=>{
        if (showSearchBar) {
            var ref;
            setSearchHistory((ref = JSON.parse(localStorage.getItem("keyWordList"))) !== null && ref !== void 0 ? ref : []);
        }
    }, [
        showSearchBar
    ]);
    (0,react.useEffect)(()=>{
        if (isGlobalConfigBlank) {
            (0,config/* getConfig */.i)().then(async (config)=>{
                let blankConfig = false;
                if (!(config && Object.keys(config).length > 1)) {
                    blankConfig = true;
                    setIsGlobalConfigBlank(true);
                }
                if (!blankConfig) {
                    setIsGlobalConfigBlank(false);
                    const vbrandName = await get_default()(config, "general.siteName", "");
                    if (vbrandName) {
                        setBrandName(vbrandName);
                    }
                    currencySign.current = get_default()(config, "internationalization.currencySign", "");
                    currencyCode.current = await get_default()(config, "internationalization.currencyCode", "");
                    knowledgeArticleUrl.current = await (0,helper.getShortenedUrl)(get_default()(config, "general.knowledgeArticlePath", ""));
                    searchPagePath.current = await (0,helper.getShortenedUrl)(get_default()(config, "general.searchPagePath", ""));
                    setRedirectTileToKohelerPLP(await (0,helper.getShortenedUrl)(get_default()(config, "general.searchPagePath", "")));
                }
            }).catch((error)=>{
                console.log(error);
            });
        }
    }, [
        isSsr,
        isGlobalConfigBlank
    ]);
    (0,react.useEffect)(()=>{
        if (data.presetConfigs) {
            dispatch((0,searchSlice/* setSearchPresetConfig */.xp)(data.presetConfigs));
        }
    }, [
        data.presetConfigs
    ]);
    const getEventInfoObj = (searchString, status, message, internalLinkURL, eventType, isserachButton, topSuggestedData)=>{
        var ref;
        const currDate = new Date();
        const contentType = window.eventPageType || "";
        const pageName = contentType === "homepage" ? "home" : contentType && contentType.split("-")[0] || "";
        const searchSuggestedTerm = [];
        if (!analyticsEventData.searchString) {
            analyticsEventData.searchString = searchString;
        }
        if (!analyticsEventData.searchTotal) {
            analyticsEventData.searchTotal = searchTotal;
        }
        if (!analyticsEventData.topSuggestedData) {
            analyticsEventData.topSuggestedData = topSuggestedData;
        }
        const searchSuggestions = searchHistory && searchHistory.length ? searchHistory : analyticsEventData.topSuggestedData && analyticsEventData.topSuggestedData.length ? analyticsEventData.topSuggestedData : [];
        if (searchSuggestions === null || searchSuggestions === void 0 ? void 0 : searchSuggestions.length) {
            searchSuggestions.slice(0, 5).map((item)=>{
                searchSuggestedTerm.push((0,helper.sanitizeTextForAnalytics)(item.productName_s || item.keyWord));
            });
        }
        const eventseachName = isserachButton ? "internal search" : "internal automatic search";
        const names = topSuggestedData ? topSuggestedData === null || topSuggestedData === void 0 ? void 0 : topSuggestedData.filter((obj)=>"productName_s" in obj).map(function(obj) {
            return obj["productName_s"];
        }) : null;
        const topsuggestions = names ? (ref = names === null || names === void 0 ? void 0 : names.join("|")) === null || ref === void 0 ? void 0 : ref.toLowerCase() : null;
        const eventInfo = {
            eventName: eventseachName,
            eventAction: eventseachName,
            internalLinkName: "internal search icon",
            internalLinkType: "global header:navigation",
            internalLinkZoneName: "global header",
            clickInternalLinks: "true",
            eventType: "global header",
            internalLinkURL: internalLinkURL ? (internalLinkURL.indexOf("http") === -1 ? window.location.origin : "") + internalLinkURL : "n/a",
            internalLinkPosition: "global header",
            eventMsg: status !== "success" ? message === null || message === void 0 ? void 0 : message.toLowerCase() : "n/a",
            eventStatus: status || "n/a",
            searchTerm: analyticsEventData.searchString,
            searchContentType: pageName ? pageName + " page" : "n/a",
            searchSuggestedTerm: topsuggestions ? topsuggestions : "n/a",
            searchCount: sessionStorage.getItem("searches") ? Number(sessionStorage.getItem("searches")) + 1 : 1,
            searchResult: analyticsEventData.searchTotal,
            internalZoneName: "search:search box",
            pageURL: window.location.href,
            referrer: document.referrer || "n/a",
            previousPage: document.referrer || "n/a",
            timeStamp: currDate.toISOString().split("T")[0] + " " + currDate.toTimeString().split(" ")[0],
            contentType: brandName === null || brandName === void 0 ? void 0 : brandName.toLowerCase()
        };
        if (eventType === null || eventType === void 0 ? void 0 : eventType.type) {
            eventType.term = (0,helper.sanitizeTextForAnalytics)(eventType.term);
            eventType.type = (0,helper.sanitizeTextForAnalytics)(eventType.type);
            eventInfo.eventName = "search:" + eventType.type + ":search term";
            eventInfo.eventAction = "search:" + eventType.type + ":search term";
            eventInfo.internalLinkZoneName = "search:" + eventType.type;
            if (eventType.type === "top suggestions") {
                var ref1;
                eventInfo.searchTerm = (ref1 = analyticsEventData.searchString) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase();
                eventInfo.searchSuggestedTerm = eventType.term;
            } else {
                eventInfo.searchTerm = eventType.term;
            }
            eventInfo.internalLinkName = eventType.term;
            eventInfo.internalZoneName = "search:" + eventType.type;
        }
        analyticsEventData = {};
        return eventInfo;
    };
    const handleSearchAnalyticsEvent = (searchString, status, message, internalLinkURL, eventType, isserachButton, topSuggestedData)=>{
        if (!internalLinkURL) internalLinkURL = redirectUrl;
        const eventInfo = getEventInfoObj(searchString, status, message, internalLinkURL, eventType, isserachButton, topSuggestedData);
        sessionStorage.setItem("searches", eventInfo.searchCount);
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        window.adobeDataLayer.push({
            event: "cmp:click",
            page,
            eventInfo
        });
    };
    const handleRedirect = (searchTerm, isAnalyticsClick, analyticsEventType, isserachButton, topSuggestedData)=>{
        setProductsLoaded(false);
        setIsCTAClicked(true);
        if (redirectUrl) {
            isAnalyticsClick && handleSearchAnalyticsEvent(searchTerm, "success", null, null, analyticsEventType);
            window.location.href = redirectUrl;
            setRedirectUrl("");
        } else {
            var ref;
            let history = (ref = JSON.parse(window.localStorage.getItem("keyWordList"))) !== null && ref !== void 0 ? ref : [];
            history = history.filter((item)=>item.keyWord.toLowerCase() !== searchTerm.toLowerCase());
            history.unshift({
                keyWord: searchTerm,
                id: Date.now()
            });
            window.localStorage.setItem("keyWordList", JSON.stringify(history));
            dispatch((0,productListSlice/* profileBrandSearch */.R$)([
                searchTerm.trim(),
                brandName.toLowerCase(),
                "sku_s, slug_s, url_s, variantList.sku_ss, Product_Category",
                1,
                ""
            ])).then(async (res)=>{
                if (res.payload) {
                    let redirectLink = "";
                    // redirect if redirect URL is configured in LW for search keyword
                    if (res.payload.fusion && res.payload.fusion.redirect && res.payload.fusion.redirect[0]) {
                        redirectLink = res.payload.fusion.redirect[0];
                        if (isAnalyticsClick) {
                            searchTerm !== searchString // do not fire same events for unchanged search string
                             ? handleSearchAnalyticsEvent(searchTerm, "success", null, redirectLink, analyticsEventType) : handleSearchAnalyticsEvent(searchTerm, "success", null, redirectLink, analyticsEventType, isserachButton, topSuggestedData);
                        }
                        window.location.href = redirectLink;
                    } else if (res.payload.response.numFound === 1 && res.payload.fusion.exactMatch) {
                        const d = res.payload.response.docs[0];
                        if (d.slug_s) {
                            const param = d.sku_s ? "skuId=".concat(d.sku_s) : "";
                            const pdpUrl = await (0,helper.getPDPUrl)(d.Product_Category, d.slug_s);
                            redirectLink = (0,utils.getPdpRedirectUrl)(pdpUrl, param);
                        } else if (d.url_s) {
                            redirectLink = d.url_s;
                        }
                        isAnalyticsClick && searchTerm !== searchString && // do not fire same events for unchanged search string
                        handleSearchAnalyticsEvent(searchTerm, "success", null, redirectLink, analyticsEventType);
                        window.location.href = redirectLink;
                    } else if (res.payload.fusion.partsCount === 1 && res.payload.fusion.partsExactMatch) {
                        const d1 = res.payload.fusion.partsDocs[0];
                        if (d1.slug_s) {
                            const param1 = d1.sku_s ? "skuId=".concat(d1.sku_s) : "";
                            const pdpUrl1 = await (0,helper.getPDPUrl)(null, d1.slug_s);
                            redirectLink = (0,utils.getPdpRedirectUrl)(pdpUrl1, param1);
                        } else if (d1.url_s) {
                            redirectLink = d1.url_s;
                        }
                        isAnalyticsClick && searchTerm !== searchString && // do not fire same events for unchanged search string
                        handleSearchAnalyticsEvent(searchTerm, "success", null, redirectLink, analyticsEventType);
                        window.location.href = redirectLink;
                    } else {
                        redirectLink = (0,helper.sanitizeUrl)(window.location.origin + (0,helper.removeAndCleanLink)(searchPagePath.current) + "?keyword=".concat(searchTerm.trim()));
                        if (isAnalyticsClick) {
                            searchTerm !== searchString // do not fire same events for unchanged search string
                             ? handleSearchAnalyticsEvent(searchTerm, "success", null, redirectLink, analyticsEventType) : handleSearchAnalyticsEvent(searchTerm, "success", null, redirectLink, analyticsEventType, isserachButton, topSuggestedData);
                        }
                        window.location.href = redirectLink;
                    }
                }
            // setProductsLoaded(true)
            }).catch((err)=>{
                console.log("Error occured while fetching Search data", err);
                isAnalyticsClick && handleSearchAnalyticsEvent(searchTerm, "failure", "error occured while fetching search data", null, analyticsEventType);
                setProductsLoaded(true);
            });
        }
    };
    const handleDelete = (id)=>{
        var ref;
        let history = (ref = JSON.parse(window.localStorage.getItem("keyWordList"))) !== null && ref !== void 0 ? ref : [];
        history = history.filter((item)=>item.id !== id);
        window.localStorage.setItem("keyWordList", JSON.stringify(history));
        setSearchHistory(history);
    };
    const handleClearAll = ()=>{
        localStorage.removeItem("keyWordList");
        setSearchHistory([]);
    };
    const handleChange = (searchTerm)=>{
        setProductsLoaded(false);
        setSearchString(searchTerm.trim());
    };
    const searchingDebounced = (0,react.useCallback)(lodash_debounce_default()(function() {
        let searchStr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        return getData(searchStr);
    }, 300), [
        prevSearch
    ]);
    (0,react.useEffect)(()=>{
        if (brandName) {
            searchString.length >= 3 ? (setPrevSearch(searchString), searchingDebounced(searchString)) : setSearchTotal(0);
            setProductsLoaded(false);
        }
        return ()=>{
            searchingDebounced.cancel();
        };
    }, [
        searchString,
        brandName,
        searchingDebounced
    ]);
    const executeTypeaheadApi = function() {
        let searchStr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", brand = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        dispatch((0,productListSlice/* profileBrandTypeahead */.zw)([
            searchStr.trim(),
            brand.toLowerCase()
        ])).unwrap().then((res)=>{
            const { response: { docs =[]  } = {}  } = res;
            docs.length && setTopSuggestedData(docs);
        });
    };
    const getData = function() {
        let searchStr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        const { disableParts  } = data;
        if (redirectUrl) setRedirectUrl("");
        if (!isCTAClicked && searchStr.length >= 3) {
            executeTypeaheadApi(searchStr, brandName);
            dispatch((0,productListSlice/* profileBrandSearch */.R$)([
                searchStr.trim(),
                brandName.toLowerCase(),
                "sku_s, slug_s, url_s, variantList.sku_ss, Product_Category",
                1,
                ""
            ])).then(async (res)=>{
                if (res.payload) {
                    // get PDP / article URL if only 1 result
                    if (res.payload.response.numFound === 1 && res.payload.fusion.exactMatch) {
                        const d = res.payload.response.docs[0];
                        if (d.slug_s) {
                            const param = d.sku_s ? "skuId=".concat(d.sku_s) : "";
                            const pdpUrl = await (0,helper.getPDPUrl)(d.Product_Category, d.slug_s);
                            setRedirectUrl((0,utils.getPdpRedirectUrl)(pdpUrl, param));
                        } else if (d.url_s) {
                            setRedirectUrl(d.url_s);
                        }
                    } else if (res.payload.fusion.partsCount === 1 && res.payload.fusion.partsExactMatch) {
                        const d1 = res.payload.fusion.partsDocs[0];
                        if (d1.slug_s) {
                            const param1 = d1.sku_s ? "skuId=".concat(d1.sku_s) : "";
                            const pdpUrl1 = await (0,helper.getPDPUrl)(null, d1.slug_s);
                            setRedirectUrl((0,utils.getPdpRedirectUrl)(pdpUrl1, param1));
                        }
                    }
                    setSearchProfileTotal(res.payload.response.numFound);
                    let groups = [
                        {
                            key: "products",
                            fq: 'Products:("ct")',
                            count: get_default()(res.payload, "facet_counts.facet_fields.Products[1]", 0)
                        },
                        {
                            key: "parts",
                            count: get_default()(res.payload.fusion.partsCount, "res.payload.fusion.partsCount", 0)
                        },
                        {
                            key: "technical",
                            fq: 'Technical:("ct")',
                            count: get_default()(res.payload, "facet_counts.facet_fields.Technical[1]", 0)
                        },
                        {
                            key: "inspiration",
                            fq: 'Inspiration:("Inspiration")',
                            count: get_default()(res.payload, "facet_counts.facet_fields.Inspiration[1]", 0)
                        },
                        {
                            key: "resource",
                            fq: 'Resource:("Resource")',
                            count: get_default()(res.payload, "facet_counts.facet_fields.Resource[1]", 0)
                        },
                        {
                            key: "help",
                            fq: 'Help:("sf")',
                            count: get_default()(res.payload, "facet_counts.facet_fields.Help[1]", 0)
                        }
                    ];
                    if (disableParts) {
                        groups = groups.filter((arr)=>{
                            return arr.key !== "parts";
                        });
                    }
                    // Calculating the total results
                    let total = 0;
                    const selected = groups.find((group)=>group.count > 0);
                    if (res.payload.fusion.exactMatch || res.payload.fusion.partsExactMatch) {
                        total = selected.key === "parts" ? res.payload.response.numFound : res.payload.fusion.partsCount;
                    } else {
                        groups.forEach((group)=>total += group.count);
                    }
                    analyticsEventData.searchTotal = total;
                    analyticsEventData.redirectUrl = redirectUrl;
                    analyticsEventData.topSuggestedData = {
                        ...topSuggestedData
                    };
                    analyticsEventData.selectedData = selected;
                    analyticsEventData.searchString = searchStr.trim();
                    setSearchTotal(total);
                    setRedirectUrl(redirectUrl);
                    const fullCatalogResponse = get_default()(res.payload, "fusion.full_catalog_Response", []);
                    if (fullCatalogResponse.length > 0) {
                        setIsSterling(true);
                        setSearchTotal(1);
                        setTopSuggestedData(fullCatalogResponse);
                    }
                    setFusioFullCatalognResponse(fullCatalogResponse);
                    handleSearchAnalyticsEvent(searchStr, "success");
                    setSelectedData(selected);
                }
            }).catch((err)=>{
                setProductsLoaded(true);
                console.error("Error occured while fetching Search data", err);
            });
        } else {
            setSearchTotal(0);
            setCategory("");
            setTilesData([]);
            setRedirectUrl("");
            setTopSuggestedData([]);
            setSearchProfileTotal(0);
        }
    };
    (0,react.useEffect)(()=>{
        if (searchTotal > 0 && selectedData.key) {
            getTilesData(selectedData);
        }
    }, [
        searchTotal,
        selectedData
    ]);
    const getTilesData = (selected)=>{
        const fl = [
            "id",
            "sku_s",
            "slug_s",
            "metaTitle_s",
            "productName_s",
            "masterSKU_s",
            "masterCustomerFacingSKU_s",
            "Product_Category",
            "ProductBrandName_s",
            "productImages.url_ss",
            "displayPriceStartingAt_s",
            "SKUColorSwatchFilename_ss",
            "ProductDescriptionProductShort_s",
            "url_s",
            "urlName_s",
            "title_s",
            "pageTitle_s",
            "eyeBrowText_s",
            "templateType_s",
            "thumbNailImage_s",
            "searchDescription_s",
            "layoutItems.Article_Type__c.value_s",
            "layoutItems.KM_Article_Content__c.value_s",
            "layoutItems.KBNA_3C_Image_Video__c.label_s",
            "layoutItems.KBNA_3C_Image_Video__c.value_s",
            "priceList.".concat(persona, ".price_d"),
            "priceList.".concat(persona, ".finalPrice_d"),
            "priceList.".concat(persona, ".discountedPrice_d"),
            "priceList.".concat(persona, ".saleOffer_s"),
            "priceStartingAt.".concat(persona, "_d"),
            "discountedPriceStartingAt.".concat(persona, "_d"),
            "Color.SKU.Details_ss",
            "Color.".concat(persona, ".Details_ss"),
            "ProductIsExclusive_s",
            "RegionReleaseforShipment_dt",
            "productImages.labelWithUrl_ss",
            "variantList.sku_ss",
            "RegionOnBackOrder_s",
            "RegionBrandName_s",
            "ctId_s",
            "primaryBundleSKU_s",
            "pdp_url_s"
        ];
        setXfLink("");
        setPromoLayout("one-column");
        setCategory("");
        setTilesData([]);
        dispatch(selected.key === "parts" ? (0,productListSlice/* profileServicePartsSearch */.n7)([
            searchString.trim(),
            fl.join(","),
            6
        ]) : (0,productListSlice/* profileBrandSearch */.R$)([
            searchString.trim(),
            brandName.toLowerCase(),
            fl.join(","),
            6,
            selected.fq
        ])).then((res)=>{
            var ref;
            if (res.payload && ((ref = res.payload.response) === null || ref === void 0 ? void 0 : ref.docs)) {
                var ref1;
                setCategory(selected.key);
                setTilesData((ref1 = res.payload.response) === null || ref1 === void 0 ? void 0 : ref1.docs);
                if ((fusionFullCatalogResponse === null || fusionFullCatalogResponse === void 0 ? void 0 : fusionFullCatalogResponse.length) > 0) {
                    setTilesData(fusionFullCatalogResponse);
                }
                if (res.payload.fusion && res.payload.fusion.experiment_fragments && res.payload.fusion.experiment_fragments !== undefined) {
                    var ref2, ref3, ref4, ref5;
                    var ref6;
                    setPromoLayout((ref6 = (ref3 = (ref2 = res.payload.fusion) === null || ref2 === void 0 ? void 0 : ref2.experiment_fragments[0]) === null || ref3 === void 0 ? void 0 : ref3.promoLayout_s) !== null && ref6 !== void 0 ? ref6 : "one-column");
                    var ref7;
                    setXfLink((ref7 = (ref5 = (ref4 = res.payload.fusion) === null || ref4 === void 0 ? void 0 : ref4.experiment_fragments[0]) === null || ref5 === void 0 ? void 0 : ref5.url_s) !== null && ref7 !== void 0 ? ref7 : "");
                }
            }
            setProductsLoaded(true);
        });
    };
    const bodyRef = (0,react.useRef)(document.body);
    const htmlRef = (0,react.useRef)(document.getElementsByTagName("html")[0]);
    const handleToggle = ()=>{
        var ref;
        showSearchBar ? (0,helper.addMavenoidChat)() : lib/* isMobile */.tq ? (0,helper.removeMavenoidChat)() : (0,helper.addMavenoidChat)();
        setSearchString("");
        setSearchTotal(0);
        const classNames = [
            "searchbar-open",
            "scroll-lock"
        ];
        classNames.map((className)=>{
            var ref, ref1;
            return bodyRef === null || bodyRef === void 0 ? void 0 : (ref = bodyRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.toggle(className);
        });
        classNames.map((className)=>{
            var ref, ref1;
            return htmlRef === null || htmlRef === void 0 ? void 0 : (ref = htmlRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.toggle(className);
        });
        setShowSearchBar(!showSearchBar);
        const page = window.pageObj || {};
        const previousPageNameForSearch = page === null || page === void 0 ? void 0 : (ref = page.pageInfo) === null || ref === void 0 ? void 0 : ref.pageName;
        sessionStorage.setItem("previousPageNameForSearch", previousPageNameForSearch);
    };
    const handleLogin = (e)=>{
        e.preventDefault();
        isAuth ? router.push("/en/my-account/my-favorites") : dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true
        }));
    };
    const themeChange =  true && winWidth <= 1200 && (document.body.classList.contains("nav-light-theme") || document.body.classList.contains("nav-dark-theme"));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (UtilityWidgets_module_default()).utilityWidgetsWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "utilitywidgets ".concat(columnClassNames ? columnClassNames : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                role: "list",
                className: "utility-widgets",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        role: "listitem",
                        className: "search-widget",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    className: "search-button gbh-data-layer bg-transparent",
                                    tabIndex: "0",
                                    role: "button",
                                    "aria-label": "Search",
                                    "data-gbh-data-layer": '{"eventAction":"internal search","eventName":"internal search","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"internal search magnifying glass button","internalLinkPosition":"global header","internalLinkType":"global navigation","internalLinkZoneName":"global header","internalLinkURL":"n/a","clickInternalLinks":"true"}',
                                    onClick: handleToggle,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "search-text",
                                            children: searchHeader
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "search-icon",
                                            children: themeChange ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                role: "presentation",
                                                src: iconSearch,
                                                alt: "search-icon"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                role: "presentation",
                                                src: "data:image/svg+xml;base64,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",
                                                alt: "search-icon"
                                            })
                                        })
                                    ]
                                }),
                                showSearchBar && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchPanel, {
                                    showSearchBar: showSearchBar,
                                    onToggle: handleToggle,
                                    onRedirect: handleRedirect,
                                    onChange: handleChange,
                                    searchString: searchString,
                                    brand: brandName,
                                    searchTotal: searchTotal,
                                    topSuggestedData: topSuggestedData,
                                    searchHistory: searchHistory,
                                    xfLink: xfLink,
                                    category: category,
                                    removeFromCompare: product/* removeFromCompareProduct */.Zj,
                                    addToCompare: product/* addToCompareProduct */.dX,
                                    tilesData: tilesData,
                                    productsLoaded: productsLoaded,
                                    promoLayout: promoLayout,
                                    favorites: (ref = (0,helper.getFavouraties)()) === null || ref === void 0 ? void 0 : ref.lineItems,
                                    comparedProducts: (0,helper.getCompareData)(),
                                    currencySign: currencySign.current,
                                    knowledgeArticleUrl: knowledgeArticleUrl.current,
                                    presetConfigs: data.presetConfigs,
                                    onDelete: handleDelete,
                                    onClearAll: handleClearAll,
                                    isSterling: isSterling,
                                    sterlingData: fusionFullCatalogResponse,
                                    parent: "Utility Widgets",
                                    searchPagePath: redirectTileToKohelerPLP,
                                    searchProfileTotal: searchProfileTotal
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        role: "listitem",
                        className: "wishlist-widget d-lg-none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            "aria-label": "View your wishlist",
                            className: "gbh-data-layer",
                            onClick: handleLogin,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                "aria-hidden": "true",
                                alt: "Wishlist",
                                src: lineItems && lineItems.length > 0 ? constants.FULL_FAVORITE_BASE64 : constants.EMPTY_FAVORITE_BASE64
                            })
                        })
                    }),
                    !(data === null || data === void 0 ? void 0 : data.disableMiniCart) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        role: "listitem",
                        className: "cart-indicator-widget d-lg-none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniCart/* default */.Z, {
                            source: "from mobile",
                            eventHandler: eventHandler
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var v1_UtilityWidgets = (UtilityWidgets);

// EXTERNAL MODULE: ./node_modules/lodash/throttle.js
var throttle = __webpack_require__(23493);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
// EXTERNAL MODULE: ./components/Shared/HeaderNavTabs/index.module.scss
var index_module = __webpack_require__(52498);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./components/Shared/HeaderNavTabs/utils.js
var HeaderNavTabs_utils = __webpack_require__(68446);
// EXTERNAL MODULE: ./components/Shared/UtilityNavHeader.jsx + 14 modules
var UtilityNavHeader = __webpack_require__(95518);
;// CONCATENATED MODULE: ./components/Shared/HeaderNavTabs/HeaderNavTabsV3/index.jsx












const TabPanel = dynamic_default()(()=>__webpack_require__.e(/* import() */ 2183).then(__webpack_require__.bind(__webpack_require__, 32183)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(32183)
            ]
    },
    ssr: false
});
const HeaderNavTabsV3 = (props)=>{
    const { data , columnClassNames ="" , eventHandler: { store: { isOpen  } , callbacks: { toggleMenu =()=>{} , setMainCategory =()=>{}  }  } , wrapperId =""  } = props || {};
    const element = data[":items"];
    const isMobile =  true && window.innerWidth <= 1200;
    const iconCloseMedium = "/icons/close-medium.svg";
    const [navOpen, setNavOpen] = (0,react.useState)("");
    const smartCrop = (0,useSmartCrop/* default */.Z)();
    const [selectedTab, setSelectedTab] = (0,react.useState)("");
    const [darkThemeFlag, setDarkThemeFlag] = (0,react.useState)(false);
    const [activeIndex, setActiveIndex] = (0,react.useState)(null);
    const [selectedId, setSelectedId] = (0,react.useState)(null);
    const [selectedNavTabIndex, setSelectedNavTabIndex] = (0,react.useState)(null);
    const [showTab, setShowTab] = (0,react.useState)(false);
    const { globalConfig ={}  } = (0,es/* useSelector */.v9)(genericSlice.selectGenericState);
    const { general: { navigationHoverTiming =""  } = {}  } = globalConfig;
    let timerout;
    let timerout2;
    const menuVisible = (0,react.useRef)(0);
    const dataRecursion = (0,react.useCallback)((data)=>{
        if (data === null || data === void 0 ? void 0 : data[":itemsOrder"]) {
            var ref;
            data === null || data === void 0 ? void 0 : (ref = data[":itemsOrder"]) === null || ref === void 0 ? void 0 : ref.map((key, index)=>{
                const item = element[key];
                return dataRecursion(item);
            });
        }
    }, []);
    const onClickNav = (data, str, navTabIndex)=>{
        if (data) {
            if (selectedTab !== data["cq:panelTitle"]) {
                setSelectedTab(data["cq:panelTitle"]);
            }
            if (navOpen !== data["cq:panelTitle"]) {
                setNavOpen(data["cq:panelTitle"]);
                if (!isMobile) {
                    setNavOpen(data["cq:panelTitle"]);
                }
                setMainCategory({
                    item: data["cq:panelTitle"]
                });
                menuVisible.current = 1;
                (0,helper.preventBodyScrollTab)(true);
                // setSelectedNavTabIndex(null)
                setActiveIndex(null);
                setSelectedId(null);
                if (str === "title click") {
                    setShowTab(true);
                    setSelectedNavTabIndex(navTabIndex);
                }
                isMobile && str === "title click mob" && (0,analytics/* l1DatalayerclickMobile */.bL)(data["cq:panelTitle"]);
            } else {
                str === "mobile back btn" && (0,analytics/* backClickForMobile */.Ps)(selectedTab);
                setShowTab(false);
                setNavOpen("");
                setSelectedTab("");
                setMainCategory({
                    item: ""
                });
                menuVisible.current = 0;
                (0,helper.preventBodyScrollTab)(false);
            }
        }
    };
    const handleEnterClickForTab = (e)=>{
        if (e.keyCode === 13) {
            setTimeout(()=>onClickNav(element[e.target.id]), 50);
        }
    };
    const handleAccordionClick = (index, id, navTabIndex)=>{
        setActiveIndex(activeIndex === index && selectedId === id ? null : index);
        setSelectedId(selectedId === id && activeIndex === index ? null : id);
        setSelectedNavTabIndex(selectedNavTabIndex === navTabIndex ? null : navTabIndex);
    };
    const levelOneLengthsArray = [];
    const handleMouseLeave = ()=>{
        setNavOpen("");
        setSelectedTab("");
        setMainCategory({
            item: ""
        });
        menuVisible.current = 0;
        (0,helper.preventBodyScrollTab)(false);
    };
    const onMenuClickEvent = (e)=>{
        var ref, ref1, ref2, ref3, ref4;
        if (((e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : (ref1 = ref.classList) === null || ref1 === void 0 ? void 0 : ref1.contains("gbh-pro-menu__inner")) || (e === null || e === void 0 ? void 0 : (ref2 = e.target) === null || ref2 === void 0 ? void 0 : ref2.closest(".gbh-pro-menu__inner")) === null && (e === null || e === void 0 ? void 0 : (ref3 = e.target) === null || ref3 === void 0 ? void 0 : ref3.closest(".gbh-full-w-menu__inner")) === null && (e === null || e === void 0 ? void 0 : (ref4 = e.target) === null || ref4 === void 0 ? void 0 : ref4.closest(".cmp-tabs__tablist")) === null && !isMobile) && menuVisible.current) {
            setNavOpen("");
            setSelectedTab("");
            setMainCategory({
                item: ""
            });
            menuVisible.current = 0;
            (0,helper.preventBodyScrollTab)(false);
        }
    };
    (0,react.useEffect)(()=>{
        const anchorElements = document.querySelectorAll(".gbh-full-w-menu__inner a:not([href])");
        anchorElements === null || anchorElements === void 0 ? void 0 : anchorElements.forEach((anchor)=>{
            anchor.style.textDecoration = "none";
            anchor.style.cursor = "default";
        });
        if (levelOneLengthsArray[selectedNavTabIndex] !== -1) {
            setActiveIndex(levelOneLengthsArray[selectedNavTabIndex]);
            setSelectedId(levelOneLengthsArray[selectedNavTabIndex]);
        }
    }, []);
    (0,react.useEffect)(()=>{
        var ref, ref1, ref2, ref3;
        if (document === null || document === void 0 ? void 0 : (ref = document.getElementsByTagName) === null || ref === void 0 ? void 0 : (ref1 = ref.call(document, "body")) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.className) === null || ref3 === void 0 ? void 0 : ref3.includes("nav-dark-theme")) {
            setDarkThemeFlag(true);
        }
    }, []);
    (0,react.useEffect)(()=>{
        if (navOpen) {
            document.addEventListener("click", onMenuClickEvent);
        } else {
            document.removeEventListener("click", onMenuClickEvent);
        }
        return ()=>document.removeEventListener("click", onMenuClickEvent);
    }, [
        navOpen
    ]);
    (0,react.useEffect)(()=>{
        dataRecursion(data);
    }, [
        data,
        dataRecursion
    ]);
    const getInternalLinkURLS = (url)=>{
        if (true) {
            return !((url === null || url === void 0 ? void 0 : url.startsWith("/")) || (url === null || url === void 0 ? void 0 : url.includes(window.location.hostname)) || url === null);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "HEADER ID",
        className: (index_module_default()).headerNavV3Wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tabs ".concat((data === null || data === void 0 ? void 0 : data.appliedCssClassNames) ? data === null || data === void 0 ? void 0 : data.appliedCssClassNames : "gbh-global-tab", " ").concat(columnClassNames, " ").concat(isOpen ? "open" : ""),
            id: wrapperId,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "cmp-tabs ".concat(darkThemeFlag ? "dark-theme" : "light-theme"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "gbh-hamber-menu gbh-close icon-Close-Medium",
                        "aria-label": "close button",
                        tabIndex: "0",
                        onClick: ()=>{
                            toggleMenu();
                            isMobile && (0,analytics/* closeButtonDatalayer */.zw)(selectedTab);
                            onClickNav({
                                "cq:panelTitle": navOpen
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: iconCloseMedium,
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                        onMouseOver: (timerout)=>{
                            timerout = setTimeout(()=>{
                                !isMobile ? (event)=>{
                                    onClickNav(element[event.target.id]);
                                } : null;
                            }, navigationHoverTiming);
                        },
                        onClick: !isMobile ? (event)=>{
                            onClickNav(element[event.target.id]);
                        } : null,
                        onMouseLeave: ()=>{
                            clearTimeout(timerout);
                            !isMobile ? handleMouseLeave : null;
                        },
                        role: "tablist",
                        className: "cmp-tabs__tablist",
                        "aria-multiselectable": "false",
                        children: [
                            data[":itemsOrder"] && data[":itemsOrder"].map((key, navTabIndex)=>{
                                var ref, ref1;
                                const itemType = element[key];
                                const item = ((ref = itemType[":items"]) === null || ref === void 0 ? void 0 : ref.globalnavigation) || itemType[":items"][(ref1 = Object.keys(itemType[":items"])) === null || ref1 === void 0 ? void 0 : ref1.find((key)=>key.includes("globalnavigation_v3"))];
                                const { firstImagesblock ={} , secondImagesblock ={} , navigationMenuType: menuType = "" , navTitle ="" , levelOneNavMulti =[] , multiCTA =[]  } = item || {};
                                levelOneLengthsArray.push((0,HeaderNavTabs_utils/* checkSingleNonEmptyLevelThreeNavMulti */.JI)(levelOneNavMulti));
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tab-panel-container ".concat((0,HeaderNavTabs_utils/* pureTextWithoutSpace */.TX)(itemType["cq:panelTitle"])),
                                    "aria-expanded": navOpen === itemType["cq:panelTitle"],
                                    style: {
                                        display: "flex",
                                        flexDirection: "column"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            onMouseOver: (event)=>{
                                                timerout2 = setTimeout(()=>{
                                                    !isMobile ? onClickNav(element[event.target.id], "title click mob") : null;
                                                }, navigationHoverTiming);
                                            },
                                            onMouseLeave: ()=>{
                                                clearTimeout(timerout2);
                                            },
                                            "aria-label": "Tab for ".concat(itemType["cq:panelTitle"], "  ").concat(navOpen === itemType["cq:panelTitle"] ? "expanded" : "collapsed"),
                                            id: key,
                                            onClick: (event)=>onClickNav(element[event.target.id], "title click", navTabIndex),
                                            onFocus: !isMobile ? ()=>{
                                                setNavOpen("");
                                            } : null,
                                            onFocusCapture: !isMobile ? ()=>setNavOpen("") : null,
                                            onKeyDown: (e)=>handleEnterClickForTab(e),
                                            role: "link",
                                            className: "cmp-tabs__tab ".concat(navOpen === itemType["cq:panelTitle"] ? "cmp-tabs__tab--active" : ""),
                                            tabIndex: "0",
                                            children: itemType["cq:panelTitle"]
                                        }, "navItem-".concat(navTabIndex)),
                                        !isMobile || isMobile && showTab ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanel, {
                                            firstImagesblock: firstImagesblock,
                                            secondImagesblock: secondImagesblock,
                                            itemType: itemType,
                                            staticClasses: constants.staticClasses,
                                            handleMouseLeave: handleMouseLeave,
                                            onClickNav: onClickNav,
                                            navOpen: navOpen,
                                            darkThemeFlag: darkThemeFlag,
                                            menuType: menuType,
                                            selectedTab: selectedTab,
                                            navTitle: navTitle,
                                            levelOneNavMulti: levelOneNavMulti,
                                            activeIndex: activeIndex,
                                            getInternalLinkURLS: getInternalLinkURLS,
                                            multiCTA: multiCTA,
                                            handleAccordionClick: handleAccordionClick,
                                            smartCrop: smartCrop,
                                            navTabIndex: navTabIndex,
                                            levelOneLengthsArray: levelOneLengthsArray,
                                            selectedNavTabIndex: selectedNavTabIndex,
                                            setActiveIndex: setActiveIndex,
                                            setSelectedId: setSelectedId,
                                            selectedId: selectedId
                                        }) : null
                                    ]
                                }, key + navTabIndex);
                            }),
                            (data === null || data === void 0 ? void 0 : data.mainTabId) && Object.keys(data === null || data === void 0 ? void 0 : data.mainTabId).map((key, index)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    role: "tab",
                                    className: "cmp-tabs__tab",
                                    tabIndex: "0",
                                    children: key
                                }, "navItem-".concat(index));
                            })
                        ]
                    }),
                    isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilityNavHeader/* default */.Z, {
                        data: element,
                        toggleMenu: toggleMenu,
                        eventHandler: props === null || props === void 0 ? void 0 : props.eventHandler
                    }) : null
                ]
            })
        })
    });
};
/* harmony default export */ var HeaderNavTabs_HeaderNavTabsV3 = (HeaderNavTabsV3);

;// CONCATENATED MODULE: ./components/Shared/HeaderNav.jsx













const HeaderNav = (props)=>{
    const dispatch = (0,es/* useDispatch */.I0)();
    const isSsr = (0,useIsSsr/* default */.Z)();
    const { menu: { isOpen  }  } = (0,es/* useSelector */.v9)(genericSlice.selectGenericState);
    const { data ={} , eventHandler , v3 =false  } = props;
    const toggleMenu = ()=>{
        isOpen ? dispatch((0,genericSlice.closeMenu)()) : dispatch((0,genericSlice.openMenu)());
    };
    const [scrollDir, setScrollDir] = (0,react.useState)("scrolling down");
    const [lastScrollY, setLastScrollY] = (0,react.useState)(0);
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        const threshold = 0;
        let lastScrollY = window.pageYOffset;
        let ticking = false;
        const updateScrollDir = ()=>{
            const scrollY = window.pageYOffset;
            if (Math.abs(scrollY - lastScrollY) < threshold) {
                ticking = false;
                return;
            }
            if (!document.body.classList.contains("gbh-of-scroll")) setScrollDir(scrollY > lastScrollY ? "scrolling down" : "scrolling up");
            lastScrollY = scrollY > 0 ? scrollY : 1;
            ticking = false;
            setLastScrollY(lastScrollY);
        };
        const onScroll = ()=>{
            if (!ticking) {
                window.requestAnimationFrame(updateScrollDir);
                ticking = true;
            }
        };
        const onScrollThrottle = throttle_default()(onScroll, 1000);
        if ((router === null || router === void 0 ? void 0 : router.pathname) !== "/checkout") {
            window.removeEventListener("scroll", onScrollThrottle);
            window.addEventListener("scroll", onScrollThrottle);
        }
        return ()=>window.removeEventListener("scroll", onScrollThrottle);
    }, [
        router
    ]);
    (0,react.useEffect)(()=>{
        if (scrollDir === "scrolling down") {
            (0,utils.alterClass)("gbh-header-logo-menu", "nav-down", "nav-up");
            (0,utils.alterClass)("sticky-plp-listing", "nav-down", "nav-up");
            (0,utils.alterClass)("sticky-pdp-page", "nav-down", "nav-up");
        } else if (scrollDir === "scrolling up") {
            (0,utils.alterClass)("gbh-header-logo-menu", "nav-up", "nav-down");
            (0,utils.alterClass)("sticky-plp-listing", "nav-up", "nav-down");
            (0,utils.alterClass)("sticky-pdp-page", "nav-up", "nav-down");
        } else return;
    }, [
        scrollDir,
        lastScrollY
    ]);
    (0,react.useEffect)(()=>{
        if (lastScrollY < 200) {
            (0,utils.alterClass)("gbh-header-logo-menu", null, "nav-down");
            (0,utils.alterClass)("gbh-header-logo-menu", null, "nav-up");
        }
    }, [
        lastScrollY,
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(data === null || data === void 0 ? void 0 : data.gridClassNames),
        children: data[":itemsOrder"].map((key, index)=>{
            const item = data[":items"][key];
            if (key.includes("image")) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_HeaderNavLogo, {
                    v3: v3,
                    data: item,
                    columnClassNames: "".concat(data.columnClassNames[key]),
                    eventHandler: eventHandler,
                    isOpen: isOpen,
                    ariaControls: constants.HEADER_NAV_TABS_WRAPPER_ID
                }, "logo-".concat(index));
            }
            if (key === null || key === void 0 ? void 0 : key.includes("tabs")) {
                if (v3) {
                    var ref;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderNavTabs_HeaderNavTabsV3, {
                        data: item,
                        columnClassNames: "".concat(data === null || data === void 0 ? void 0 : (ref = data.columnClassNames) === null || ref === void 0 ? void 0 : ref.key),
                        isOpen: isOpen,
                        toggleMenu: toggleMenu,
                        eventHandler: eventHandler,
                        wrapperId: constants.HEADER_NAV_TABS_WRAPPER_ID
                    }, "tabs-".concat(index));
                } else {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Shared_HeaderNavTabs, {
                        data: item,
                        columnClassNames: "".concat(data.columnClassNames[key]),
                        isOpen: isOpen,
                        toggleMenu: toggleMenu,
                        eventHandler: eventHandler,
                        wrapperId: constants.HEADER_NAV_TABS_WRAPPER_ID
                    }, "tabs-".concat(index));
                }
            }
            if (key === null || key === void 0 ? void 0 : key.includes("utilitywidgets")) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: !isSsr ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_UtilityWidgets, {
                        data: item,
                        columnClassNames: "".concat(data.columnClassNames[key]),
                        eventHandler: eventHandler
                    }) : null
                }, "utilitywidgets-".concat(index));
            }
            return null;
        })
    });
};
/* harmony default export */ var Shared_HeaderNav = (HeaderNav);


/***/ }),

/***/ 18377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useSmartCrop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83886);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2595);




const DynamicImage = (param)=>{
    let { imgUrl ="" , alt ="" , className ="" , uniqueId ="" , urlModifiers ="" , ...restProps } = param;
    const smartCrop = (0,_hooks_useSmartCrop__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const cropedImage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const imgPlaceholder = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    const isScene7Img = imgUrl === null || imgUrl === void 0 ? void 0 : imgUrl.includes("scene7");
    const [bgColorImage, setBgColorImage] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!isSsr && smartCrop.scriptStatus && isScene7Img && window.s7responsiveImage) {
            smartCrop.applySmartCrop(cropedImage.current);
        }
    }, [
        smartCrop.scriptStatus,
        imgUrl,
        window.s7responsiveImage,
        uniqueId,
        isSsr
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (urlModifiers && imgUrl) {
            setBgColorImage((imgUrl === null || imgUrl === void 0 ? void 0 : imgUrl.includes("?")) ? "".concat(imgUrl, "&").concat(urlModifiers) : "".concat(imgUrl, "?").concat(urlModifiers));
        }
    }, [
        imgUrl,
        urlModifiers
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        ref: cropedImage,
        src: imgPlaceholder,
        "data-src": urlModifiers ? bgColorImage : imgUrl,
        "data-mode": "smartcrop",
        alt: alt,
        className: className,
        ...restProps
    }, uniqueId);
};
/* harmony default export */ __webpack_exports__["default"] = (DynamicImage);


/***/ }),

/***/ 52498:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headerNavV3Wrapper":"HeaderNavTabs_headerNavV3Wrapper__HLJt6"};

/***/ })

}]);